module.exports = __webpack_public_path__ + "img/835-a7db79.png";